import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDeclinedUsersRequestAction } from "../../../../../redux/actions/customerActions";
import CustomTable from "components/CustomTable";
import { GET_DECLINED_USERS } from "config/apiRoutes";
// --------------------------------------------------------------------------------
const DeclinedUsers = () => {
  const dispatch = useDispatch();

  const { approvedUsers } = useSelector((state) => ({
    approvedUsers: state.customer.approvedUsers,
  }));
  const [data, setData] = useState({ records: [], count: 0 });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  useEffect(() => {
    dispatch(
      getDeclinedUsersRequestAction({
        setData,
        limit: pagination.pageSize,
        offset: pagination.pageIndex + 1,
      })
    );
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => `${row.firstName} ${row.lastName}`,
        header: "User's Full Name",
        size: 150,
        Cell: ({ cell, row }) => (
          <Link to={`/users/pending-users/${row.original.id}`}>
            {cell.getValue()}
          </Link>
        ),
      },
      {
        accessorKey: "agent",
        header: "Agent",
        size: 150,
      },
      {
        accessorKey: "email", //normal accessorKey
        header: "Email",
        size: 200,
        Cell: ({ cell, row }) => {
          return row.original.pepStatus == "starter" ? (
            <Link to={`/app/profile/${row.original.id}/Summary`}>
              {cell.getValue()}
            </Link>
          ) : (
            <span>{cell.getValue()}</span>
          );
        },
      },
      // {
      //   accessorKey: "email", //normal accessorKey
      //   header: "Email",
      //   size: 200,
      //   Cell: ({ cell, row }) => (
      //     <Link to={`/users/pending-users/${row.original.id}`}>
      //       {cell.getValue()}
      //     </Link>
      //   ),
      // },
      {
        accessorKey: "country_code",
        header: "Mobile Country Code",
        size: 150,
      },
      {
        accessorKey: "mobile",
        header: "Mobile",
        size: 150,
      },
      {
        accessorKey: "registerTime",
        header: "Register Time",
        size: 150,
      },
    ],
    []
  );

  return (
    <CustomTable
      title="Declined Users"
      data={data.records}
      columns={columns}
      onPaginationChange={setPagination}
      state={{ pagination, loading: false }}
      rowCount={data.count}
    />
  );
};

export default DeclinedUsers;
